import { theme, observable, observer, ui } from "aaa";
import * as React from "react";

// This is a drop in replacement for material ui TextField
interface IProps {
    style?: React.CSSProperties;
    inputStyle?: React.CSSProperties;
    lineHeight?: number;
    hintText?: string;

    // input props
    type?: string;
    inputMode?: string;
    disabled?: boolean;
    id?: string;
    value?: string | number;
    autoComplete?: "on" | "off";

    // multiline
    multiLine?: boolean;
    rows?: number;

    onChange?(event: any, value: string): void;
    onFocus?(): void;
    onBlur?(): void;
}

@observer
export class NativeTextField extends React.Component<IProps> {
    @observable value: string | number;

    constructor(props: IProps) {
        super(props);
        this.value = props.value || "";
    }

    render() {
        const { style, onChange, inputStyle, hintText, value, multiLine, rows, type, lineHeight: customLineHeight, ...inputProps } = this.props;

        const nativeOnChange = (event: any) => {
            this.value = event.target.value;

            if (this.props.onChange) {
                this.props.onChange(event, event.target.value);
            }
        };

        // If we want dynamically growing textareas look here for calculating number of lines
        // https://stackoverflow.com/questions/2035910/how-to-get-the-number-of-lines-in-a-textarea or
        // https://stackoverflow.com/questions/1760629/how-to-get-number-of-rows-in-textarea-using-javascript/1761203#1761203

        const _inputStyle = {
            outline: "none",
            background: "none",
            border: "none",
            width: "100%",
            height: "100%",
            font: "inherit",
            ...this.props.inputStyle,
        };

        const lineHeight = customLineHeight ?? 24;
        const _rows = rows || 1;

        return (
            <div
                style={{
                    height: (_rows + 1) * lineHeight,
                    lineHeight: `${lineHeight}px`,
                    fontSize: "16px",
                    position: "relative",
                    ...style
                }}
            >
                <div
                    style={{
                        display: "flex",
                        height: "100%",
                        alignItems: "center"
                    }}
                >
                    {!multiLine && <input
                        className="theme-textfield theme-textfield-color"
                        placeholder={hintText}
                        value={value}
                        type={type && type !== "number" ? type : undefined}
                        {...inputProps}
                        onChange={nativeOnChange}
                        style={_inputStyle}
                        id={this.props.id}
                    />}
                    {multiLine && <textarea
                        className="theme-textfield theme-textfield-color"
                        placeholder={hintText}
                        value={value}
                        {...inputProps}
                        onChange={nativeOnChange}
                        style={{
                            ..._inputStyle,
                            height: rows ? rows * lineHeight : "100%",
                            resize: "none",
                        }}
                        rows={rows}
                        id={this.props.id}
                    />}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/NativeTextField.tsx